import { render, staticRenderFns } from "./CourseBoardCard.vue?vue&type=template&id=1288d698&scoped=true&"
import script from "./CourseBoardCard.vue?vue&type=script&lang=ts&"
export * from "./CourseBoardCard.vue?vue&type=script&lang=ts&"
import style0 from "./CourseBoardCard.vue?vue&type=style&index=0&id=1288d698&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288d698",
  null
  
)

export default component.exports